import _ from "lodash";
import React, { useEffect, useState } from "react";
import classes from "./PostPreview.scss";
import TaggedFolders from "Post/components/TaggedFolders";
import StudentActivities from "Post/components/StudentActivities";
import DualProfile from "Post/components/DualProfile";
import { getTimeSince } from "Utils";
import { colors } from "Constants";
import { Trans } from "react-i18next";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";
import { Modal, Tooltip, Alert } from "@toddle-edu/ds-web";
import { FolderOutlined } from "@toddle-edu/ds-icons";
// import { getFormattedStudentName } from "Post/utils";
import TheatreModeV2 from "UIComponents/TheatreModeV2";
import StudentActivityDetail from "Post/components/StudentActivityDetail";
import classNames from "classnames";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getSettingValue } from "modules/PermissionModule";
import { connect } from "react-redux";
import moment from "moment";

import { getDefaultStudentNameOrderPreference } from "modules/CommonSelectors";

import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { getFormattedUserNameWithoutPronoun } from "Post/utils";

const CardHeader = ({
  studentActivities,
  creatorDetails: { id, name, profileImage },
  sharedWithDetails,
  publishedAt,
  isTheatreMode = false,
  onClick,
  t,
  defaultStudentNameOrderPreference,
}) => {
  const renderTaggedtext = () => {
    if (_.size(studentActivities) === 1) {
      return (
        <p className={classes.taggedMessageText}>
          {/* Following <Trans> results: {teacher} tagged {student} */}
          <Trans i18nKey="journal:teacher_tagged_student">
            <b className={classes.userText}>{{ teacherName: name }}</b>
            <b className={classes.userText}>
              {{
                studentName: getFormattedUserName({
                  user: _.get(studentActivities, "0.item.activityStudent"),
                  type: "student",
                }),
              }}
            </b>
          </Trans>
        </p>
      );
    }
    if (!isTheatreMode && _.size(studentActivities) === 2) {
      return (
        <p className={classes.taggedMessageText}>
          {/* Following <Trans> results: {user} tagged {student1} and {student2} */}
          <Trans i18nKey="journal:user_tagged_student_and_student">
            <b className={classes.userText}>{{ user: name }}</b>
            <b className={classes.userText}>
              {{
                student1: getFormattedUserName({
                  user: _.get(studentActivities, "0.item.activityStudent"),
                  type: "student",
                }),
              }}
            </b>
            <b className={classes.userText}>
              {{
                student2: getFormattedUserName({
                  user: _.get(studentActivities, "1.item.activityStudent"),
                  type: "student",
                }),
              }}
            </b>
          </Trans>
        </p>
      );
    }
    if (!isTheatreMode && _.size(studentActivities) > 2) {
      return (
        <p className={classes.taggedMessageText}>
          {/* Following <Trans> results: {user} tagged {student} and {remainingStudentsCount} others */}
          <Trans i18nKey="journal:user_tagged_student_and_others">
            <b className={classes.userText}>{{ user: name }}</b>
            <b className={classes.userText}>
              {{
                student: getFormattedUserName({
                  user: _.get(studentActivities, "1.item.activityStudent"),
                  type: "student",
                }),
              }}
            </b>
            <b className={classes.userText}>
              <Tooltip
                tooltip={
                  <span>
                    {_.map(studentActivities, (student, index) => (
                      <span key={index}>
                        {/* {getFormattedStudentName(student, [
                          "item",
                          "activityStudent",
                        ])} */}
                        {getFormattedUserName({
                          user: _.get(student, "item.activityStudent"),
                          type: "student",
                        })}
                      </span>
                    ))}
                  </span>
                }
              >
                {{ remainingStudentsCount: _.size(studentActivities) - 1 }}
              </Tooltip>
            </b>
          </Trans>
        </p>
      );
    }
    return (
      <p className={classes.taggedMessageText}>
        <b className={classes.userText}>{name}</b>
      </p>
    );
  };

  const headerContainer = classNames({
    [classes.headerContainer]: true,
    [classes.postPreviewHeaderContainer]: isTheatreMode,
    [classes.cursorPointer]: _.isFunction(onClick),
  });

  return (
    <div
      onClick={_.isFunction(onClick) ? onClick : null}
      className={headerContainer}
    >
      <DualProfile
        user1={{ id, value: name, imageUrl: profileImage }}
        user2={
          isTheatreMode && _.size(studentActivities) > 1
            ? {}
            : {
                id: _.get(studentActivities, "0.item.activityStudent.id", ""),
                value: getFormattedUserNameWithoutPronoun({
                  user: _.get(studentActivities, "0.item.activityStudent"),
                  type: "student",
                }),
                imageUrl: _.get(
                  studentActivities,
                  "0.item.activityStudent.profileImage",
                  ""
                ),
              }
        }
      />
      <div>
        {renderTaggedtext()}
        <p className={classes.headerSubtext}>
          <span className={classes.headerSubtextIcon}>
            <Tooltip tooltip={sharedWithDetails.text}>
              {sharedWithDetails.icon}
            </Tooltip>
          </span>
          <span className={classes.headerSubtextDot}></span>
          <span>
            {_.isEmpty(publishedAt)
              ? t("common:now")
              : moment(publishedAt).isAfter(moment())
              ? t("common:scheduled_for_with_label", {
                  label: moment(publishedAt).format("MMM DD YYYY, hh:mm A"),
                })
              : getTimeSince(publishedAt, t)}
          </span>
        </p>
      </div>
    </div>
  );
};

const PostPreview = ({
  t,
  setIsPostPreviewOn,
  activityCriteriaSets,
  studentActivityData,
  selectedStudents,
  selectedFolders,
  creatorDetails,
  sharedWithDetails,
  publishedAt,
  alertVisiblitySettings,
  handleAlertClose,
  defaultStudentNameOrderPreference,
}) => {
  const alertInitialState = !_.isEmpty(_.get(sharedWithDetails, "alertKey"))
    ? _.get(
        alertVisiblitySettings,
        ["previewAlert", _.get(sharedWithDetails, "alertKey")],
        false
      )
    : false;

  const [studentActivities, setStudentActivities] = useState([]);
  const [shouldShowAlert, setShouldShowAlert] = useState(!alertInitialState);
  const [shouldShowTheatreMode, setShouldShowTheatreMode] = useState(false);
  const [theatreAttachmentIndex, setTheatreAttachmentIndex] = useState(0);
  const [attachments, setAttachments] = useState([]);
  const [selectedStudentId, setSelectedStudentId] = useState(null);

  const getIbPYPElementRatings = studentRatings => {
    const ibPYPElementRatings = [];
    _.forEach(activityCriteriaSets, (activityCriteriaSet, index) => {
      const id = _.get(activityCriteriaSet, "id", "");
      const label = _.get(activityCriteriaSet, "label", "");
      const criteriaValues = _.get(
        activityCriteriaSet,
        "academicCriteriaValues",
        []
      );
      const currentStudentCriteriaValueId = _.get(studentRatings, [
        id,
        "value",
      ]);
      const currentStudentCriteriaValue = _.find(
        criteriaValues,
        criteriaValue =>
          _.get(criteriaValue, "id", "") === currentStudentCriteriaValueId
      );
      if (_.isNil(currentStudentCriteriaValue)) return;
      ibPYPElementRatings.push({
        id: index,
        academicCriteriaSet: { id, label },
        academicCriteriaValue: currentStudentCriteriaValue,
      });
    });
    return ibPYPElementRatings;
  };

  const getAttachments = attachmentData => {
    const attachments = [];
    _.forEach(attachmentData, attachment => {
      attachments.push(_.get(attachment, "value", {}));
    });
    return attachments;
  };

  const getStudentActivities = () => {
    const activityData = [];
    if (_.isEmpty(selectedStudents) || _.isEmpty(studentActivityData)) return;

    _.forEach(selectedStudents, (student, index) => {
      const id = _.get(student, "node.id", "");
      const firstName = _.get(student, "node.firstName", "");
      const lastName = _.get(student, "node.lastName", "");
      const middleName = _.get(student, "node.middleName", "");
      const pronouns = _.get(student, "node.pronouns", "");
      const suffix = _.get(student, "node.suffix", "");
      const preferredName = _.get(student, "node.preferredName", "");
      const profileImage = _.get(student, "node.profileImage", "");
      const data = _.get(studentActivityData, [id, "criteria"]);
      const description = _.get(
        studentActivityData,
        [id, "description", "value"],
        ""
      );
      const startTime = _.get(
        studentActivityData,
        [id, "startTime", "value"],
        ""
      );
      const endTime = _.get(studentActivityData, [id, "endTime", "value"], "");
      const activityType = _.get(studentActivityData, "activityType", "");
      const attachmentData = _.get(
        studentActivityData,
        [id, "attachments"],
        []
      );
      const ibPYPElementRatings = getIbPYPElementRatings(data);
      const attachments = getAttachments(attachmentData);

      activityData.push({
        item: {
          id: index,
          activityType,
          activityStudent: {
            id,
            firstName,
            lastName,
            profileImage,
            middleName,
            suffix,
            pronouns,
            preferredName,
          },
          ibPYPElementRatings,
          description,
          startTime,
          endTime,
          attachmentGroups: [{ attachments }],
        },
      });
    });

    setStudentActivities(activityData);
  };

  useEffect(() => {
    getStudentActivities();
  }, []);

  const handleActivitySelectedStudentAttachmentsChange = (_, attachments) => {
    setAttachments(attachments);
  };

  const handleActivitySelectedStudentChange = studentId => {
    setSelectedStudentId(studentId);
    setShouldShowTheatreMode(true);
  };

  const handleActivitySelectedStudentIdChange = studentId => {
    setSelectedStudentId(studentId);
  };

  const resetTheatreMode = () => {
    setShouldShowTheatreMode(false);
    setTheatreAttachmentIndex(0);
    setAttachments([]);
    setSelectedStudentId(null);
  };

  if (shouldShowTheatreMode)
    return (
      <TheatreModeV2
        mediaAttachments={{ attachments }}
        activeAttachmentIndex={theatreAttachmentIndex}
        toggleTheatreMode={resetTheatreMode}
        sidePaneContent={props => (
          <div className={classes.postPreviewContainer}>
            {!_.isEmpty(studentActivities) ? (
              <div>
                <CardHeader
                  t={t}
                  studentActivities={studentActivities}
                  creatorDetails={creatorDetails}
                  sharedWithDetails={sharedWithDetails}
                  publishedAt={publishedAt}
                  isTheatreMode={true}
                  defaultStudentNameOrderPreference={
                    defaultStudentNameOrderPreference
                  }
                />
                <div className={classes.postPreviewActivitiesContainer}>
                  <StudentActivityDetail
                    studentActivities={studentActivities}
                    activitySelectedStudentId={selectedStudentId}
                    handleActivitySelectedStudentAttachmentsChange={
                      handleActivitySelectedStudentAttachmentsChange
                    }
                    handleActivitySelectedStudentIdChange={
                      handleActivitySelectedStudentIdChange
                    }
                    theatreActiveAttachmentIndex={_.get(
                      props,
                      "theatreActiveAttachmentIndex",
                      0
                    )}
                    setTheatreAttachmentIndex={_.get(
                      props,
                      "setTheatreAttachmentIndex",
                      () => {}
                    )}
                    leftButtonStyle={{
                      left: 0,
                      width: "24px",
                      height: "24px",
                      transform: "translateY(-126%)",
                    }}
                    rightButtonStyle={{
                      right: 0,
                      width: "24px",
                      height: "24px",
                      transform: "translateY(-126%)",
                    }}
                    defaultStudentNameOrderPreference={
                      defaultStudentNameOrderPreference
                    }
                  />
                </div>
              </div>
            ) : null}
            {!_.isEmpty(selectedFolders) ? (
              <div>
                <div className={classes.separator} />
                <div className={classes.postPreviewFolderContainer}>
                  <div className={classes.folderHeaderContainer}>
                    <span className={classes.folderheaderIcon}>
                      <FolderOutlined size={"xx-small"} variant="critical" />
                    </span>
                    <span className={classes.folderHeaderText}>
                      {t("journal:tagged_folders")}
                    </span>
                  </div>
                  <TaggedFolders
                    folders={selectedFolders}
                    showFolderIcon={true}
                    tagSize={"small"}
                    containerStyle={{
                      marginTop: "16px",
                      gap: "8px",
                    }}
                    singleTagTextStyle={{
                      fontSize: "1.6rem",
                      colors: colors.textDefault,
                    }}
                  />
                </div>
              </div>
            ) : null}
          </div>
        )}
      />
    );

  return (
    <Modal
      hasOverlay={true}
      height={"max-content"}
      width={"654px"}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onClose={() => setIsPostPreviewOn(false)}
    >
      <Modal.Header title={t("journal:post_preview")} />
      <Modal.Body style={{ paddingRight: "24px", paddingLeft: "32px" }}>
        {!_.isEmpty(sharedWithDetails.alertText) && shouldShowAlert ? (
          <div className={classes.alertContainer}>
            <Alert
              type="info"
              message={sharedWithDetails.alertText}
              isClosable={true}
              onClose={() =>
                !_.isNil(_.get(sharedWithDetails, "alertKey"))
                  ? handleAlertClose(
                      {
                        ...alertVisiblitySettings,
                        previewAlert: {
                          ..._.get(alertVisiblitySettings, "previewAlert", {}),
                          [_.get(sharedWithDetails, "alertKey")]: true,
                        },
                      },
                      setShouldShowAlert
                    )
                  : null
              }
            />
          </div>
        ) : null}
        {!_.isEmpty(studentActivities) ? (
          <div className={classes.activityContainer}>
            <CardHeader
              t={t}
              studentActivities={studentActivities}
              creatorDetails={creatorDetails}
              sharedWithDetails={sharedWithDetails}
              publishedAt={publishedAt}
              onClick={() => setShouldShowTheatreMode(true)}
              defaultStudentNameOrderPreference={
                defaultStudentNameOrderPreference
              }
            />
            <div className={classes.activitiesContainer}>
              <StudentActivities
                studentActivities={studentActivities}
                activitiesContainerStyle={{ paddingInline: "0px" }}
                handleActivitySelectedStudentChange={
                  handleActivitySelectedStudentChange
                }
                onMediaClick={({ activeIndex }) =>
                  setTheatreAttachmentIndex(activeIndex)
                }
                defaultStudentNameOrderPreference={
                  defaultStudentNameOrderPreference
                }
              />
            </div>
          </div>
        ) : null}
        {!_.isEmpty(selectedFolders) ? (
          <div className={classes.folderContainer}>
            <div className={classes.folderHeaderContainer}>
              <span className={classes.folderheaderIcon}>
                <FolderOutlined size={"xx-small"} variant="critical" />
              </span>
              <span className={classes.folderHeaderText}>
                {t("journal:tagged_folders")}
              </span>
            </div>
            <TaggedFolders
              folders={selectedFolders}
              showFolderIcon={true}
              tagSize={"small"}
              containerStyle={{
                marginTop: "16px",
                gap: "8px",
              }}
              singleTagTextStyle={{
                fontSize: "1.6rem",
                colors: colors.textDefault,
              }}
            />
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  return {
    /* { creationAlert: boolean, previewAlert: { families: boolean, students: boolean, public: boolean } } */
    alertVisiblitySettings:
      getSettingValue({
        name: "TeacherPortal:ClosedActivityTrackingInfoModal",
        userId: userInfo.id,
        organizationId: userInfo.org_id,
        courseId: _.get(state, "teacher.selected_class.selected_course"),
        readFromUserAndOrgLevel: true,
      }) || {},
    defaultStudentNameOrderPreference,
  };
};

export default compose(
  connect(mapStateToProps, null),
  I18nHOC({ resource: ["journal", "common"] })
)(PostPreview);
